import { Component, Injectable, ViewChild, OnInit } from '@angular/core';
import { RequestsService } from '../../services/requests.service';
import { ToastService } from '../../services/toast.service';
import { ModalComponent, ModalConfig } from '../../_helpers/modal/modal.component'
import { ModalperguntaComponent } from '../../_helpers/modalpergunta/modalpergunta.component'
import { Template } from '../../models/template.model';
import { Dataset } from '../../models/dataset.model';
import { Cabecalho } from '../../models/cabecalho.model';
import { MonacoEditorComponent } from '@materia-ui/ngx-monaco-editor';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'add-template',
  styleUrls: ['./add-template.component.scss'],
  templateUrl: "./add-template.component.html"
})

export class AddTemplateComponent implements ModalConfig, OnInit {
  templateForm: FormGroup;
  submitted = false;
  disableSubmit = false;
  public data: string;
  public idProjeto: number;
  public modalTitle = "Cadastro/Edição de Template";
  public modalperguntaTitle = "Tem certeza que gostaria de excluir o Template?";
  public closeButtonLabel = "Fechar";


  editorOptions = { theme: 'vs-dark', language: 'html' };
  @ViewChild('editor', { static: true }) private editor: MonacoEditorComponent
  @ViewChild('modal', { static: true }) private modalComponent: ModalComponent
  @ViewChild('modalpergunta', { static: true }) private modalperguntaComponent: ModalperguntaComponent

  template: Template = new Template();
  datasets: Dataset[] = [];
  cabecalhos: Cabecalho[] = [];

  constructor(private formBuilder: FormBuilder,private requestService: RequestsService, private toastService: ToastService) { }

  ngOnInit() {
    this.templateForm = this.formBuilder.group({
      nome: ['', Validators.required],
      nomeArquivo: ['', Validators.required],
      dataset: [''],
      cabecalho: [''],
      html: ['', Validators.required]
    })
  }

  get f() { return this.templateForm.controls; }

  public hideDismissButton() {
    return true;
  }

  async abrir(registro, idProjeto) {
    this.submitted = false;
    this.disableSubmit = false;
    this.templateForm.markAsUntouched();

    if (registro)
      this.template = registro;
      else
      this.template = new Template();

    this.idProjeto = idProjeto;
    this.iniciar();
    return await this.modalComponent.open();
  }

  async fechar() {
    await this.modalComponent.close();
  }

  salvar() {
    this.submitted = true;

    if (this.templateForm.invalid) {
      return;
    }

    this.disableSubmit = true;
    this.template.idProjeto = this.idProjeto;
    var request = this.template.idTemplate > 0 ? this.requestService.updateTemplate(this.template) : this.requestService.insertTemplate(this.template);

    request.subscribe(rsp => {
      this.fechar();
      this.toastService.showSuccess("Template salvo com sucesso.");
    }, err => {
      this.disableSubmit = false;
    });
  }

  async delete(id) {
    await this.modalperguntaComponent.open();
    return await this.modalperguntaComponent.continue(this.modalperguntaComponent.isConfirmed);
  }

  iniciar() {
    this.requestService.listDatasetsByProjeto(this.idProjeto).subscribe(x => {
      this.datasets = x;
    });
    this.requestService.listCabecalhosByProjeto(this.idProjeto).subscribe(x => {
      this.cabecalhos = x;
    });
  }

}
